import {lazy} from 'react';

export const FinalTermsLazy = lazy(() => import(/* webpackChunkName: "samDocumentSearch-finalTerms" */ '.'));
